import { RenderLeafProps } from 'slate-react'

export function LeafComponent({ attributes, children, leaf }: RenderLeafProps) {
    if (leaf.bold) {
        children = <b>{children}</b>
    }

    if (leaf.italics) {
        children = <i>{children}</i>
    }

    if (leaf.underline) {
        children = <u>{children}</u>
    }

    return (
        <span style={{ color: leaf.color, background: leaf.background }} {...attributes}>
            {children}
        </span>
    )
}
